function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKennzeichenKontrakt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10,
    cy: 10,
    r: 10,
    style: {
      fill: "#0588cc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    style: {
      fill: "#fff"
    },
    d: "m9.39 9.84 4.1-4.07h-1.85L7.87 9.55V5.77H6.32v8.46h1.55v-3.94l3.92 3.94h1.89L9.39 9.84z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKennzeichenKontrakt);
export default __webpack_public_path__ + "static/media/icon-kennzeichen-kontrakt.1c2b159ba10a413e71e05db6222cb489.svg";
export { ForwardRef as ReactComponent };